import { FormPagePropertyItemMailRefusalFlag } from 'backend';
import {
  FormPageInputData,
  MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE,
} from 'shared';
import { MAIL_REFUSAL_FLAG_VALUE_TYPE } from 'shared/dist/components/parts/MailRefusalFlagInput/shared';
import { PropertyItemElement } from '../getPropertyItemElements';

export const getMailRefusalFlagInputValue = (
  propertyItem: FormPagePropertyItemMailRefusalFlag,
  propertyItemElement: PropertyItemElement,
): FormPageInputData => {
  switch (propertyItem.inputFormat?.inputType) {
    case MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE.radio: {
      const radioElements = propertyItemElement.radios;
      const isAllRadio =
        Array.isArray(radioElements) &&
        radioElements.every(
          (element) =>
            element instanceof HTMLInputElement && element.type === 'radio',
        );

      if (!isAllRadio) {
        return {};
      }
      const checkedValue =
        (radioElements as HTMLInputElement[]).find((element) => element.checked)
          ?.value || null;
      const radios = document.querySelectorAll<HTMLElement>(
        `input[name="${propertyItem.propertyId}"]`,
      );
      if (radios.length == 0) {
        return {};
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'mailRefusalFlagRadio',
          isRefused: checkedValue
            ? checkedValue === MAIL_REFUSAL_FLAG_VALUE_TYPE.refusal
            : undefined,
        },
      };
    }
    default: {
      return {};
    }
  }
};
